export default __webpack_public_path__ + "static/media/CenterContentMobile.058e75c3.png";